import { SVGProps, memo } from 'react';
const HeartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={props.width || "25"} height={props.height || "25"} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="heart">
    <path id="Vector 511" d="M6.3872 11.3543L13 18.1162L19.6128 11.3543C21.2177 9.71318 21.2177 7.09067 19.6128 5.4496C17.867 3.66443 14.9618 3.77578 13.3578 5.68935L13 6.11621L12.6422 5.68935C11.0382 3.77578 8.13299 3.66443 6.3872 5.4496C4.78234 7.09067 4.78233 9.71318 6.3872 11.3543Z" stroke={props.stroke || "#424242"} strokeOpacity={props.strokeOpacity || "0.5"} strokeLinecap={props.strokeLinecap || "round"} strokeLinejoin={props.strokeLinejoin || "round"} fill={props.fill || "none"}/>
    </g>
  </svg>
);

export default memo(HeartIcon);
